import React from 'react'
import { Document, Page, Text, Image } from '@react-pdf/renderer';

let desc = '';
let sol = '';
if(sessionStorage.tipoInforme === '1'){
    //desc = 'Señor: \nDe mi considerción:\nSolicito a Ud.:\nSe establezcan los días de licencia ordinaria generada en el ejercicio ';

}else{
    //desc = 'El tipo de i';
}

const InformesReglamentaria = ({ datoFun }) => (
    <>
    {datoFun.codigo === 1 || datoFun.codigo === 2
    ?
        sol = '\n\n\nSolicitado el ' + datoFun.solicitado.substring(8,10) + '/' + datoFun.solicitado.substring(5,7) + '/' + datoFun.solicitado.substring(0,4)
    :
        null
    }
    
    {datoFun.codigo === 1
    ?
        desc = 'Jefe/Encargado: \nSolicito a Ud. el usufructo de ' + datoFun.dias + ' día/s de licencia reglamentaria generadas en el ejercicio ' + datoFun.anio + ', desde el ' + datoFun.desde.substring(8,10) + '/' + datoFun.desde.substring(5,7) + '/' + datoFun.desde.substring(0,4)
        + ' hasta el ' + datoFun.hasta.substring(8,10) + '/' + datoFun.hasta.substring(5,7) + '/' + datoFun.hasta.substring(0,4) + ' inclusive.'
    :
        datoFun.codigo === 2
        ?
            desc = 'Jefe/Encargado: \nSolicito a Ud. el usufructo de ' + datoFun.dias + ' día/s de licencia por antigüedad generadas en el ejercicio ' + datoFun.anio + ', desde el ' + datoFun.desde.substring(8,10) + '/' + datoFun.desde.substring(5,7) + '/' + datoFun.desde.substring(0,4)
            + ' hasta el ' + datoFun.hasta.substring(8,10) + '/' + datoFun.hasta.substring(5,7) + '/' + datoFun.hasta.substring(0,4) + ' inclusive.'
        :
            null
    }
    <Document>
        <Page size='A4' style={{paddingTop: 35, paddingBottom: 65, paddingHorizontal: 35}}>
            <Image style={{ width: '50%'}} src="img/Institucional.jpg"/>
            <Text style={{fontSize: 24, textAlign: 'center'}}>{datoFun.titulo}</Text>
            <Text style={{margin: 8, fontSize: 14, textAlign: 'justify', fontFamily: 'Times-Roman'}}>
                {desc}
            </Text>
            <Text style={{margin: 8, fontSize: 14, textAlign: 'justify', textAlign: 'right', fontFamily: 'Times-Roman'}}>
                {sol}
            </Text>
            <Image style={{marginVertical: 8, marginLeft:300, width: 200}} src={datoFun.firmaFuncionario}/>
            <Text style={{margin: 8, fontSize: 14, textAlign: 'justify', fontFamily: 'Times-Roman', display: 'inline'}}>{'Pase al Departamento de Recursos Humanos:'}</Text>
            <Image style={{marginVertical: 5, marginLeft:300, width: 200}} src={datoFun.firmaJefe}/>
            <Text style={{margin: 8, fontSize: 14, textAlign: 'justify', fontFamily: 'Times-Roman'}}>
                {'Se tomo nota para Salario Vacacional:'}
            </Text>
            <Image style={{marginVertical: 8, marginLeft:300, width: 200}} src={datoFun.firmaVacacional}/>
            <Text style={{margin: 8, fontSize: 14, textAlign: 'justify', fontFamily: 'Times-Roman'}}>
                {'Se registró en su ficha, se incorporó al sistema'}
            </Text>
            <Image style={{marginVertical: 8, marginLeft:300, width: 200}} src={datoFun.firmaSistema}/>
            <Text style={{margin: 8, fontSize: 14, textAlign: 'justify', fontFamily: 'Times-Roman'}}>
                {'El Departamento de Recursos Humanos informa que el funcionario N° ' + datoFun.numeroFuncionario + ' ' + datoFun.nombreFuncionario + ' tiene generado por el ejercicio ' + datoFun.anio + ':'}
                {'\n' + datoFun.diasReglamentaria + ' día/s de licencia reglamentaria'}
                {'\n' + datoFun.diasAntiguedad + ' día/s de antigüedad'}
                {'\nFaltas con Aviso: ' + datoFun.conAviso + ' días'}
                {'\nFaltas sin Aviso: ' + datoFun.sinAviso + ' días'}
                {'\nSuspensión: ' + datoFun.suspension + ' días'}
                {'\nLicencia Extraordinaria sin sueldo: ' + datoFun.extraordinaria + ' días'}
                {'\nSe autoriza lo solicitado.'}
            </Text>
            <Text style={{margin: 8, fontSize: 14, textAlign: 'justify', fontFamily: 'Times-Roman'}}>
                {'Firma por Departamento de RR.HH'}
            </Text>
            <Image style={{marginVertical: 8, marginLeft:300, width: 200}} src={datoFun.firmaJefeFinal}/>
        </Page>
    </Document>
    </>
);



export default InformesReglamentaria